import React from "react";
import { Alert, Container, Navbar, NavbarBrand } from "react-bootstrap";
import NavbarToggle from "react-bootstrap/esm/NavbarToggle";
import { Link, useParams } from "react-router-dom";
import { ErrorMessages } from './Shared/ErrorMessages';

export default function ErrorPage() {
    const urlParams : any = useParams();

    const hasErrorId = urlParams && !!urlParams.errorId && urlParams.errorId in ErrorMessages;
    const errorMessage = hasErrorId ? ErrorMessages[urlParams.errorId] : ErrorMessages["UnexpectedError"]

    return (
        <Container>
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3">
                    <Container>
                        <NavbarBrand as={Link} to="/">Physician Portal</NavbarBrand>
                        <NavbarToggle><span className="navbar-toggler-icon"></span></NavbarToggle>
                    </Container>
                </Navbar>
            </header>
            <div>
                <Alert variant="pp-alert-danger">{errorMessage}</Alert>
            </div>
        </Container>
    );
}